import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {toPayload} from '../lib/types/payload'
import {ContentfulIndex} from './copilot/ContentfulIndex'
import {DefaultIndex} from './copilot/DefaultIndex'
import resolveResponse from 'contentful-resolve-response'
import {isFeatureCopilotPage, toContainerPage, toEntryCollection} from '../lib/types/contentful'

export function CopilotIndex() {
  const {copilotSignupPath} = useRoutePayload<{copilotSignupPath: string}>()
  const {copilotForBusinessSignupPath} = useRoutePayload<{copilotForBusinessSignupPath: string}>()
  const {copilotContactSalesPath} = useRoutePayload<{copilotContactSalesPath: string}>()
  const {copilotHeroSignupPath} = useRoutePayload<{copilotHeroSignupPath: string}>()
  const {isCopilotPlansPageEnabled} = useRoutePayload<{isCopilotPlansPageEnabled: boolean}>()
  const {copilotHydroTracking} = useRoutePayload<{copilotHydroTracking: string}>()
  const {contentfulRawJsonResponse} = toPayload(useRoutePayload<unknown>())

  // empty hash {} when contentful is disabled
  if (Object.keys(contentfulRawJsonResponse).length > 0) {
    const page = toContainerPage(toEntryCollection(resolveResponse(contentfulRawJsonResponse)).at(0))

    if (isFeatureCopilotPage(page)) {
      return (
        <ContentfulIndex
          copilotSignupPath={copilotSignupPath}
          copilotForBusinessSignupPath={copilotForBusinessSignupPath}
          copilotContactSalesPath={copilotContactSalesPath}
          copilotHeroSignupPath={copilotHeroSignupPath}
          isCopilotPlansPageEnabled={isCopilotPlansPageEnabled}
          copilotHydroTracking={copilotHydroTracking}
          contentfulRawJsonResponse={contentfulRawJsonResponse}
          page={page}
        />
      )
    }
  }

  return (
    <DefaultIndex
      copilotSignupPath={copilotSignupPath}
      copilotForBusinessSignupPath={copilotForBusinessSignupPath}
      copilotContactSalesPath={copilotContactSalesPath}
      copilotHeroSignupPath={copilotHeroSignupPath}
      isCopilotPlansPageEnabled={isCopilotPlansPageEnabled}
      copilotHydroTracking={copilotHydroTracking}
    />
  )
}

try{ CopilotIndex.displayName ||= 'CopilotIndex' } catch {}